<template>
    <div>
        <div class="top">
            <div class="topleft">
                <el-breadcrumb separator="/">
                    <el-breadcrumb-item :to="{ path: '/home' }">{{$t('home')}}</el-breadcrumb-item>
                    <el-breadcrumb-item>{{$t('oter1')}}</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
        </div>
        <div class="cont">
            <div class="listbox">
                <div class="listright" v-loading="loading">
                    <div class="search">
                        <div class="searchleft">
                            <el-form :inline="true" :model="searchform" class="demo-form-inline" @submit.native.prevent >
                                <el-form-item :label="$t('phone')">
                                    <el-input v-model="searchform.phone" style="width: 150px;" @keyup.enter.native="onSubmit" size="small"></el-input>
                                </el-form-item>
                                <el-form-item :label="$t('mchOrderNo')">
                                    <el-input v-model="searchform.mchOrderNo" style="width: 150px;" @keyup.enter.native="onSubmit" size="small"></el-input>
                                </el-form-item>
                                <el-form-item :label="$t('skzh')">
                                    <el-input v-model="searchform.cuenta" style="width: 150px;" @keyup.enter.native="onSubmit" size="small"></el-input>
                                </el-form-item>
                                <el-form-item :label="$t('type')">
                                    <el-select v-model="searchform.statusValue" style="width:120px;">
                                        <el-option :label="$t('buxian')" :value="null"></el-option>
                                        <el-option :label="$t('loan4')" :value="0"></el-option>
                                        <el-option :label="$t('loan5')" :value="1"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item :label="$t('time')">
                                    <el-date-picker
                                    v-model="value1"
                                    type="datetimerange"
                                    size="small"
                                    range-separator="至"
                                    value-format="yyyy-MM-dd HH:mm:ss"
                                    start-placeholder="开始时间"
                                    end-placeholder="结束时间">
                                    </el-date-picker>
                                </el-form-item>
                                <el-form-item>
                                    <el-button size="small" type="primary" @click="onSubmit">{{$t('query')}}</el-button>
                                </el-form-item>
                            </el-form>
                        </div>
                    </div>
                    <el-table :data="list"
                        :header-cell-style="{'background':'#f5f5f5','font-weight':'bold','color':'#555555','padding':'6px 0'}" style="width: 100%">
                        <el-table-column prop="phone" :label="$t('phone')"></el-table-column>
                        <el-table-column prop="orderNo" :label="$t('orderNo')"></el-table-column>
                        <el-table-column prop="mchOrderNo" :label="$t('mchOrderNo')"></el-table-column>
                        <el-table-column prop="money" :label="$t('dkje')"></el-table-column>
                        <el-table-column prop="days" :label="$t('days')"></el-table-column>
                        <el-table-column prop="amount" :label="$t('fkje')"></el-table-column>
                        <el-table-column prop="costo" :label="$t('fwf')"></el-table-column>
                        <el-table-column prop="interes" :label="$t('lx')"></el-table-column>
                        <el-table-column prop="cantidad" :label="$t('ssje')"></el-table-column>
                        <el-table-column prop="cuenta" :label="$t('skzh')"></el-table-column>
                        <el-table-column prop="level" :label="$t('createTime')">
                            <template slot-scope="scope">
                                {{scope.row.createTime|changedate}}
                            </template>
                        </el-table-column>
                        <el-table-column prop="expireTime" :label="$t('expireTime')"></el-table-column>
                        <el-table-column prop="loanTime" :label="$t('fksj')"></el-table-column>
                        <el-table-column prop="status" :label="$t('status')">
                            <template slot-scope="scope">
                                <el-tag v-if="scope.row.status==3" type="warning" size="mini" :title="$t('fksb')">{{$t('fksb')}}</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column prop="body" :label="$t('pingt')"></el-table-column>
                        <el-table-column prop="statusValue" :label="$t('status')" width="100">
                            <template slot-scope="scope">
                                <el-tag v-if="scope.row.statusValue == 0" type="info">{{$t('loan4')}}</el-tag>
                                <el-tag v-if="scope.row.statusValue == 1" type="info">{{$t('loan5')}}</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column prop="jobName" :label="$t('operator')" width="80">
                            <template slot-scope="scope">
                                <el-tooltip class="item" effect="dark" :content="$t('oter2')" placement="top">
                                     <el-button size="small" @click="lendingAgain(scope.row)"  type="primary" icon="el-icon-menu" circle plain></el-button>
                                </el-tooltip>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="page">
                        <app-page :total="total" :current="pageNo" :pageSize="pageSize"
                            @handleCurrentChange="currentchange" @handleSizeChange="handchange"></app-page>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import apiurl from "@/api/public"
    import _api from "@/api/index"
    import Treeselect from '@riophae/vue-treeselect'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import {
        LOAD_CHILDREN_OPTIONS
    } from '@riophae/vue-treeselect'
    export default {
        components: {
            Treeselect
        },
        data() {
            var rolesValid = (rule, value, callback) => {
                callback()
            }
            return {
                searchform: {
                    blurry: "",
                },
                loading: false,
                list: [],
                value1:[],
                total: 1,
                pageNo: 1,
                pageSize: 10,
            }
        },
        created() {
            this.user=JSON.parse(localStorage.getItem("userinfo"))
            this.getList()
        },
        methods: {
            lendingAgain(row) {
                const h = this.$createElement;
                this.$msgbox({
                    title: this.$t('cffkqr'),
                    message: h('p', null, [
                        h('span', null, this.$t('orderNo1')),
                        h('i', { style: 'color: red' }, row.mchOrderNo),
                        h('br'),
                        h('span', null, this.$t('fkje1')),
                        h('i', { style: 'color: red' }, row.amount),
                        h('br'),
                        h('span', null, this.$t('phone1')),
                        h('i', { style: 'color: red' }, row.phone)
                    ]),
                    showCancelButton: true,
                    confirmButtonText: this.$t('login3'),
                    cancelButtonText: this.$t('qux'),
                    beforeClose: (action, instance, done) => {
                        if (action === 'confirm') {
                            instance.confirmButtonLoading = true;
                            instance.confirmButtonText = this.$t('fkz1');
                            _api.get(apiurl.lendingAgain, {
                                orderId : row.id
                            }).then(res => {
                                this.$notify({
                                    title: this.$t('success'),
                                    message: this.$t('oter3'),
                                    type: 'success'
                                });
                                instance.confirmButtonLoading = false;
                                done();
                                this.getList()
                            }).catch(err => {
                                this.$notify.error({
                                    title: this.$t('error'),
                                    message: err.data.message
                                });
                            })
                        } else {
                            done();
                        }
                    }
                }).then(action => {
                    this.$message({
                        type: 'info',
                        message: 'action: ' + action
                    });
                });
            },
            getList() {
                this.loading = true
                _api.get(apiurl.payError, {
                    page: this.pageNo,
                    size: this.pageSize,
                    cuenta: this.searchform.cuenta,
                    phone: this.searchform.phone,
                    mchOrderNo: this.searchform.mchOrderNo,
                    nation:localStorage.getItem("nation"),
                    platform:this.searchform.platform,
                    createTime: this.value1,
                    type: this.searchform.statusValue
                }).then(res => {
                    this.loading = false
                    this.list = res.data.data
                    this.total = res.data.totalCount
                })
            },
            onSubmit() {
                this.pageNo = 1
                this.getList()
            },
            handchange(data) { //分页Size变化
                this.pageSize = data
                this.pageNo = 1
                this.getList()
            },
            currentchange(data) { //当前页变化
                this.pageNo = data
                this.getList()
            },
        }
    }
</script>
<style scoped>
    .lefttop {
        padding: 8px;
    }

    .listbox {
        display: flex;
    }

    .listleft {
        width: 20%;
        border: 1px solid #EBEEF5;
    }

    .listright {
        width: 100%;
        margin-left: 1%;
    }

    .listrighttop {
        padding: 0 10px;
        background: rgb(245, 245, 245);
        height: 40px;
        overflow: hidden;
        line-height: 40px;
        border-bottom: 1px solid #EBEEF5;
    }

    .listrighttop strong {
        float: left;
    }

    .listrighttop span {
        float: right;
    }

    ::v-deep .vue-treeselect__control,
    ::v-deep .vue-treeselect__placeholder,
    ::v-deep .vue-treeselect__single-value {
        height: 30px;
        line-height: 30px;
    }
</style>